import { render, staticRenderFns } from "./PromptDialogDemo.vue?vue&type=template&id=c88145fc"
import script from "./PromptDialogDemo.vue?vue&type=script&lang=js"
export * from "./PromptDialogDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports